import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Chỉnh sửa tài khoản nhân viên" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Họ và tên:", -1)),
          _createVNode(_component_InputText, {
            id: "username",
            type: "text",
            modelValue: $setup.employee.fullName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.employee.fullName) = $event)),
            readonly: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Zalo Id:", -1)),
          _createVNode(_component_InputText, {
            id: "zaloid",
            type: "text",
            modelValue: $setup.employee.zaloId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.employee.zaloId) = $event)),
            readonly: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Chọn khoa/phòng", -1)),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.employee.teamCode,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.employee.teamCode) = $event)),
            options: $setup.teams,
            optionLabel: "name",
            optionValue: "code",
            placeholder: "Chọn khoa/ phòng",
            filter: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Cập nhật", -1)),
          _createVNode(_component_Button, {
            label: "Cập nhật thông tin",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.update()))
          })
        ])
      ])
    ]),
    _: 1
  }))
}